import React, { forwardRef } from "react";
import styled from "styled-components";
import classnames from "classnames";
import Loader from "../Loader";
import { SearchProvider, SearchForm, SearchResults, useSearchContext } from "../Search";
import { getSegs } from "./services/segService";
import { Button } from "react-bootstrap";
import IBuildrProps from "../../utilities/IBuildrProps";

const SegContainer = styled.div`

    background: #f1f1f1;
    padding: 40px;

    .seg-heading {
        font-weight: initial;
    }

    .search {
        position: relative;

        label {
            left: 0;
        }
    }

    .button {
        padding: 10px 20px;
        display: inline-block;
        background: ${props => props.theme.primary};
        border-radius: 3px;
        color: white;
        margin-top: 20px;
        border: 1px solid ${props => props.theme.primary};
    }

    .button:hover {
        background: transparent;
        color: ${props => props.theme.primary};
    }

    .search {
        max-width: 500px;
        margin: 0 auto;
    }

    @media(max-width: 1024px) {
        width: 100%;
    }
`;

export interface ISegProps extends IBuildrProps {
    inputPlaceholderLabel: string;
    noResultsFoundMessage: string;
    resultsFoundMessage: string;
    resultsLimit: number;
    CTAHyperLink: string;
    CTAText: string;
    containerClass: string;
    searchContainerClass: string;
    inputClass: string;
    buttonClass: string;
    lineColor: string;
    children;
}

const Seg = forwardRef((props: ISegProps, ref: any) => {
    const { cmsId, editorClassObj, CTAHyperLink, CTAText, inputPlaceholderLabel, resultsFoundMessage, noResultsFoundMessage, resultsLimit } = props;

    function ShowSecStatus() {
        const { results, debouncedSearchValue, selected, isLoading, hasError } = useSearchContext();
        if (isLoading) {
            return <Loader spinner width={5} height={5} />
        }
        if (hasError || (!isLoading && debouncedSearchValue && !results?.length)) {
            const requestError = "SEG information could not be loaded, please try again.";
            return (
                <div className="my-4 text-center">
                    <div role="alert">{hasError ? requestError : noResultsFoundMessage}</div>
                </div>
            );
        }
        if (selected && debouncedSearchValue) {
            return (
                <div className="my-4 text-center">
                    <div role="alert">{resultsFoundMessage.replace("{result}", selected)}</div>
                    <Button className="mt-4 py-3" as="a" variant="danger" href={CTAHyperLink} target="_blank">{CTAText}</Button>
                </div>
            );
        }
        return null;
    }

    return (
        <SegContainer data-id={cmsId} className={classnames(editorClassObj, props.containerClass)} ref={ref}>
            <SearchProvider>
                <div className="seg-heading">{props.children}</div>
                <SearchForm
                    limit={resultsLimit}
                    executeSearch={getSegs}
                    inputPlaceholder={inputPlaceholderLabel}
                    containerClass={props.searchContainerClass}
                    inputClass={props.inputClass}
                    lineColor={props.lineColor}
                    preventSubmit
                    />
                <SearchResults showEmpty={false} className="w-100" />
                <ShowSecStatus />
            </SearchProvider>
        </SegContainer>
    );
});

export default Seg;
(global as any).Seg = Seg;